import { render, staticRenderFns } from "./CoozzySortableItem.vue?vue&type=template&id=2b5b5fcc&scoped=true"
import script from "./CoozzySortableItem.vue?vue&type=script&lang=js"
export * from "./CoozzySortableItem.vue?vue&type=script&lang=js"
import style0 from "./CoozzySortableItem.vue?vue&type=style&index=0&id=2b5b5fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5b5fcc",
  null
  
)

export default component.exports